import { render, staticRenderFns } from "./SingleBillReportXL.vue?vue&type=template&id=0b80223c&"
import script from "./SingleBillReportXL.vue?vue&type=script&lang=js&"
export * from "./SingleBillReportXL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports